<template>
  <el-container id='wrapper'>
    <el-header>
      <PageTitle title="Calendar" :weekOnly="true"></PageTitle>
    </el-header>
    <el-main class="main">
      <div class="container">
        <UserSelector v-if="$store.getters.adminMode"></UserSelector>
        <Calendar :users="users" class="calendar"></Calendar>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PageTitle from '../components/PageTitle'
import Calendar from '../components/Calendar'
import {getRangeIndexFromDateRange} from '@/utils'
import UserSelector from '../components/UserSelector'
import moment from 'moment'

export default {
  props: [
    'users',
    'timeEntries'
  ],
  components: {
    Calendar,
    PageTitle,
    UserSelector
  },
  data () {
    return {
      currentTimeSelection: PageTitle.data
    }
  },
  computed: {
    currentDateRange: function () {
      let currentRange = this.$store.getters.currentDateRange
      let rangeIndex = getRangeIndexFromDateRange(currentRange, moment())
      let newRangeIndex = JSON.stringify({range: 'week', index: rangeIndex.index})
      return newRangeIndex
    }
  }
}
</script>

<style lang='scss' >
  @import '../styles/common.scss';
  .v-cal-button{
    display:none !important;
  }
</style>

<style lang='scss' scoped>
@import "../styles/common.scss";
.main {
  display: flex;
  align-items: stretch;
  padding-top: 0px;

  .container {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    background-color: white;
    border-radius: 10px;
    overflow-y: auto;
    overflow: overlay;
  }
  .calendar{
    flex-grow: 1;
  }
}

</style>
